import "../../assets/utils/MenuItems.css";

export const MenuItems = [
  {
    title: "Home",
    url: "/",
    cName: "nav-links",
    icon: "fa-sharp fa-solid fa-house-user",
  },
  {
    title: "About Us",
    url: "/about",
    cName: "nav-links",
    icon: "fa-sharp fa-solid fa-circle-info",
  },
  {
    title: "Services",
    url: "/services",
    cName: "nav-links",
    icon: "fa-sharp fa-solid fa-briefcase",
  },
  // {
  //   title: "Get Involved",
  //   url: "/getinvolved",
  //   cName: "nav-links",
  //   icon: "fa-sharp fa-solid fa-address-book",
  // },
  {
    title: "Contact Us",
    url: "/contactus",
    cName: "nav-links",
    icon: "fa-solid fa-phone",
  },
];
